<template lang="pug">
RatingPlace(
  :type="type",
  :place="place",
  :rating="ratingDataList",
  :date="ratingDataDate"
)
</template>

<script>
import FormatDate from "@chronos/frontend-base/src/libs/tools/FormatDate";

import RatingPlace from "./RatingPlace";

export default {
  name: "RatingGroupItem",
  components: {
    RatingPlace,
  },
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    place: {
      type: Number,
      default: 10,
    },
    ratingDataRank: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ratingDataList() {
      return this.ratingDataRank.hasOwnProperty("list") ? this.ratingDataRank.list : [];
    },
    ratingDataDate() {
      return this.ratingDataRank.hasOwnProperty("date") ? FormatDate.getFullDate(this.ratingDataRank.date) : "";
    },
  },
};
</script>
